import React from 'react';

import AttireThumbnail from './AttireThumbnail';


export default class RemindersPage extends React.Component {
  render() {
    return (
      <div id="reminders-page" className="reminders-page content-wrapper">
        <div className="content">
          <h3>Attire</h3>
          <p>
            Cocktail dress for her.
            Dress pants and button up shirt for him.
          </p>
          <div className="row">
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code-men1.jpg')} />
            </div>
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code-men2.jpg')} />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code-women1.png')} />
            </div>
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code-women2.jpg')} />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code3.jpg')} />
            </div>
            <div className="col-xs-6">
              <AttireThumbnail image={require('../../images/dressCode/dress-code4.jpg')} />
            </div>
          </div>
          <h3>Unplugged Ceremony</h3>
          <p>
            Please switch off your devices and stow them away, we’d love to see your smiles aiming our way.
            But though our “I Do”’s are unplugged, our reception is not. Once we're announced man and wife, you’re free to take a shot.
          </p>
          <h3>Gift</h3>
          <p>
            As love is what the day is all about,
            your presence is one we can’t celebrate without.
            But should you still believe that a gift is worth giving,
            a small envelope for our future is a delightful blessing.
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RemindersPage/index.js